import React from 'react';
import PaymentRates from './paymentRates';
import MonerisContainer from '../../moneris';
import BillingAddressFields from './billingAddressFields';
import { BillingAddressDto } from '../../../types';
interface Props {
  isBillingAddressSame: boolean;
  setIsBillingAddressSame: any;
  validating: boolean;
  billingForm: BillingAddressDto;
  setBillingForm: any;
  billingFormValidations: any;
  setBillingFormValidations: any;
}
function PaymentFields({
  isBillingAddressSame,
  setIsBillingAddressSame,
  validating,
  billingForm,
  setBillingForm,
  billingFormValidations,
  setBillingFormValidations,
}: Props) {
  return (
    <>
      <div className='row'>
        <div className='col-sm-12 col-md-6'>
          <div className='ubbe-card'>
            <div className='ubbe-card-header'>
              <h5 className='ps-3 mb-0 GlobalBoxHead'>Billing Address</h5>
            </div>
            <div className='card-body p-4'>
              <div className='row'>
                <div className='col-sm-12 col-md-12 my-auto'>
                  <div className='form-check'>
                    {/* <input
                    className='form-check-input'
                    type='checkbox'
                    id='is_billing_same'
                    onChange={() => {
                      // "switch_billing(this)"
                    }}
                    checked
                  /> */}
                    <input
                      className='form-check-input'
                      type='checkbox'
                      checked={isBillingAddressSame}
                      id='is_billing_same'
                      onChange={(e) => {
                        setIsBillingAddressSame(e.target.checked);
                      }}
                    />
                    <label
                      className='form-check-label'
                      htmlFor='is_billing_same'
                    >
                      Same as Origin Address?
                    </label>
                  </div>
                </div>
              </div>
              <div className='text-center py-4 divider'>or</div>

              {!isBillingAddressSame && (
                <BillingAddressFields
                  validating={validating}
                  billingForm={billingForm}
                  setBillingForm={setBillingForm}
                  billingFormValidations={billingFormValidations}
                  setBillingFormValidations={setBillingFormValidations}
                />
              )}
            </div>
          </div>
        </div>

        <div className='col-sm-12 col-md-6'>
          <PaymentRates />
        </div>

        <div className='col-sm-12 col-md-3'></div>
      </div>
      <div className='row'>
        <div className='col-sm-12 col-md-6'>
          <MonerisContainer />
        </div>
      </div>
    </>
  );
}

export default PaymentFields;
